import ModelBase from "./shared/model-base.js";

interface ContactLogAttributes {
  id: string | number;
  contact_id?: string | number;
  admin_id?: string | number;
  action?: string;
  note?: string;
  admin_name?: string;
  created_at?: string;
}

interface ModelAttributes {
  id: string | number;
  name?: string;
  phone?: string;
  email?: string;
  subject?: string;
  message?: string;
  state?: string;
  country_id: string | number;
  contact_logs?: ContactLogAttributes[];
  created_at?: string;
  updated_at?: string;
}

const OPTIONS = {
  i18nModelName: "contact",
  columns: [
    "id",
    "name",
    "phone",
    "email",
    "subject",
    "message",
    "state",
    "country_id",
    "contact_logs",
    "created_at",
    "updated_at",
  ],
  editColumns: {},
};

export default class Contact extends ModelBase {
  declare id: string | number;
  declare name: string;
  declare phone: string;
  declare email: string;
  declare subject: string;
  declare message: string;
  declare state: string;
  declare country_id: string | number;
  declare contact_logs: ContactLogAttributes[];
  declare created_at: string;
  declare updated_at: string;

  constructor(attributes: Partial<ModelAttributes> = {}) {
    super(OPTIONS, attributes);
  }
}

export type { ContactLogAttributes };
